import { push } from 'react-router-redux';
import { all, takeEvery, put, delay } from 'redux-saga/effects';

import * as actionTypes from '../constants/actionTypes';
import * as authAction from '../actions';


import axios from '../services';
import toaster from '../utils/toaster';

function getSafeNextPath() {
  const params = new URLSearchParams(window.location.search || '');
  const rawNext = params.get('next');
  if (!rawNext || !rawNext.startsWith('/') || rawNext.startsWith('//')) return '/';
  return rawNext;
}

function* loginRequest({ payload }) {
  try {
    const { username, password } = payload;
    yield put(authAction.loginClearError());
    // delete axios.defaults.headers.common['Authorization'];
    yield put(authAction.showLoader());
    let response = yield axios.post('/auth/signin', {
      username,
      password,
      rememberMe: !!payload.rememberMe,
    });

    if (response.status === 200) {
      toaster(response.message);
      yield localStorage.setItem('userToken', response.data.accessToken);
      if (response.data.refreshToken) {
        yield localStorage.setItem('refreshToken', response.data.refreshToken);
      } else {
        localStorage.removeItem('refreshToken');
      }
      yield localStorage.setItem('userData', JSON.stringify(response.data));
      yield localStorage.setItem('dp', JSON.stringify(response.data.displayPicture));
      yield localStorage.setItem('email', JSON.stringify(response.data.email));
      yield put(authAction.loginRequestSuccess(response.data.accessToken));
      window.location.assign(getSafeNextPath());
    } else {
      toaster(response.message);
      yield put(authAction.loginFail());
    }
  } catch (error) {
    const body = error.response && error.response.data;
    const msg =
      (body && (body.message || body.code)) || 'Sign in failed';
    const code = body && body.code ? String(body.code) : '';
    yield put(
      authAction.loginFail({
        message: typeof msg === 'string' ? msg : 'Sign in failed',
        code,
      })
    );
    toaster(typeof msg === 'string' ? msg : 'Sign in failed');
  }
}

function* logoutRequest() {
  try {
    let response = yield axios.post('/auth/logout');
    if (response.status == 200) {
      yield put(authAction.logoutRequestSuccess(true));
      localStorage.clear();
    }
  } catch (error) {
    if (error == 'Error: Request failed with status code 422')
      yield put(authAction.logoutRequestSuccess(true));
    else if (error == 'Error: Request failed with status code 401') {
      yield put(authAction.logoutRequestSuccess(true));
      localStorage.clear();
    } else {
      localStorage.clear();
    }
  }
}

export default function* rootsaga() {
  yield all([
    yield takeEvery(actionTypes.LOGIN_REQUEST, loginRequest),
    yield takeEvery(actionTypes.LOGOUT_REQUEST, logoutRequest),
  ]);
}
